import { Controller } from "@hotwired/stimulus";
export default class default_1 extends Controller {
    connect() { }
    toggle(event) {
        this.itemTargets.forEach((item) => {
            item.hasAttribute("hidden") ? this.show(event) : this.hide(event);
        });
    }
    show(event) {
        this.itemTargets.forEach((item) => item.removeAttribute("hidden"));
    }
    hide(event) {
        this.itemTargets.forEach((item) => item.setAttribute("hidden", ""));
    }
}
default_1.targets = ["item"];
